module.exports = __webpack_public_path__ + "img/apple-icon.9b26c71a.svg";